export const css = {
    oneaction: 'uMaK5221',
    ' _key': 'certwise-theme/certwise/quiz-widgets/prometric'
};
export default css;
